import React, { memo } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Input from '@JohnLewisPartnership/jl-design-system/elements/input/Input';
import Close24PxOutlinedIcon from '@JohnLewisPartnership/jl-design-system/elements/icons-jb/Close24PxOutlined';
import Search24PxOutlinedIcon from '@JohnLewisPartnership/jl-design-system/elements/icons-jb/Search24PxOutlined';
import styles from './FacetSearch.module.scss';

const FacetSearch = ({ label, search, onClear, onSearch, isFilterDrawer }) => {
  const hasSearchIconVisible = search.length === 0;
  const hasClearButtonVisible = search.length > 1;

  const handleSearch = (evt) => {
    const { value: newValue } = evt.target;
    onSearch(newValue);
  };

  const handleClear = () => {
    onClear();
  };

  const id = `facet-search-${label}`;
  const drawerLabel = isFilterDrawer ? 'drawer-' : '';
  const placeholderText = `Search ${label}`;

  return (
    <div
      className={classnames(styles.container, {
        [styles.filterDrawer]: isFilterDrawer,
      })}
      data-test={id}
    >
      <label htmlFor={id} className="visuallyHidden">
        {placeholderText}
      </label>
      <Input
        className={classnames({
          [styles['input--search-icon-showing']]: hasSearchIconVisible,
          [styles['input--clear-button-showing']]: hasClearButtonVisible,
        })}
        id={drawerLabel + id}
        name={id}
        value={search}
        placeholder={placeholderText}
        onChange={handleSearch}
        autoComplete="off"
      />
      {hasSearchIconVisible && (
        <span className={styles.searchIcon}>
          <Search24PxOutlinedIcon />
        </span>
      )}
      {hasClearButtonVisible && (
        <button
          onClick={handleClear}
          className={styles.clear}
          aria-label="Reset search"
        >
          <Close24PxOutlinedIcon />
        </button>
      )}
    </div>
  );
};

FacetSearch.defaultProps = {
  isFilterDrawer: false,
  label: '',
  onClear: () => {},
  onSearch: () => {},
  search: '',
};

FacetSearch.propTypes = {
  isFilterDrawer: PropTypes.bool,
  label: PropTypes.string,
  onClear: PropTypes.func,
  onSearch: PropTypes.func,
  search: PropTypes.string,
};

export default memo(FacetSearch);
